export default () => ({
	menuOpen: false, 
	isDesktop: true,
	count(){
		return Object.values(this.$store.cart.items).reduce((sum, item) => sum += item.count, 0)
	}
})